// extracted by mini-css-extract-plugin
export var sliderRange = "_lh-2";
export var sliderRoot = "_lh-0";
export var sliderThumb = "_lh-3";
export var sliderTrack = "_lh-1";